import React from 'react';
import './style.scss';

const LoadingIndicator = (props) => (
  <div className="loop-wrapper animated fadeIn">
    <h2>{props.text || `Loading...`}</h2>
    <div className="sun" />
    <div className="mountain" />
    <div className="hill" />
    <div className="tree" />
    <div className="tree" />
    <div className="tree" />
    <div className="rock" />
    <div className="truck" />
    <div className="wheels" />
  </div>
);

export default LoadingIndicator;
